































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { LocaleMixin } from '@/locales/locale-mixin';
import { LoadingStore } from '@/store/loading-store';
import { CentersStore } from '@/organizations/locations/stores/centers-store';
import { IntegrationRepository } from '@/integrations/repositories/integration-repository';
import { Center } from '@/organizations/locations/models/center';
import { LocationIntegrationToggle } from '@/integrations/models/integration';
import BaseClose from '@/components/base/BaseClose.vue';

const loadingState = getModule(LoadingStore);
const centersStore = getModule(CentersStore);
const integrationRepository = new IntegrationRepository();

@Component({
    name: 'ExportFamiliesModal',
    components: { BaseClose }
})
export default class ExportFamiliesModal extends Mixins(LocaleMixin) {
    @Prop({ default: false }) readonly value!: boolean;
    @Prop({ default: null }) readonly cmsPartnerId!: number | null;

    private loadingKey = 'exportFamilies';
    private search = '';
    private availableLocations: Array<Center> = [];
    private integratedCenters: Array<LocationIntegrationToggle> = [];
    private selectedLocationIds: Array<number> = [];

    get modelValue(): boolean {
        return this.value;
    }

    set modelValue(showIt: boolean) {
        this.$emit('input', showIt);
    }

    get showSearchBar(): boolean {
        return this.availableLocations.length > 10;
    }

    get selectedCount(): number {
        return this.selectedLocationIds.length;
    }

    get totalCount(): number {
        return this.availableLocations.length;
    }

    get selectAll(): boolean {
        return this.availableLocations.length > 0 && this.selectedCount === this.totalCount;
    }

    set selectAll(value: boolean) {
        if (value) {
            // Select all
            this.selectedLocationIds = this.availableLocations.map(location => location.id);
        } else {
            // Deselect all
            this.selectedLocationIds = [];
        }
    }

    /**
     * Filter the available locations based on the search term.
     */
    get filteredLocations(): Array<Center> {
        if (!this.search) {
            return this.availableLocations;
        }

        const searchTerm = this.search.toLowerCase();
        return this.availableLocations.filter(location =>
            location.name.toLowerCase().includes(searchTerm) ||
            location.code.toLowerCase().includes(searchTerm)
        );
    }

    @Watch('modelValue')
    async modelWatch() {
        if (this.modelValue && this.cmsPartnerId) {
            await this.loadLocations();
        }
    }

    /**
     * Load the locations for the selected CMS partner.
     */
    private async loadLocations() {
        loadingState.loadingIncrement(this.loadingKey);

        // Get integrated centers for this CMS partner
        this.integratedCenters = await integrationRepository.getLocationIntegrationsByPartnerId(this.cmsPartnerId!);

        // Get all active centers
        const allCenters: Array<Center> = centersStore.storedAll.filter(center => center.is_active);

        // Filter to only show integrated centers
        const integratedCenterIds = this.integratedCenters
            .filter(toggle => toggle.is_enabled)
            .map(toggle => toggle.center_id);

        this.availableLocations = allCenters
            .filter(center => integratedCenterIds.includes(center.id));

        loadingState.loadingDecrement(this.loadingKey);
    }

    /**
     * Export families from the selected locations.
     */
    private async exportFamilies() {
        if (this.selectedLocationIds.length === 0) {
            return;
        }
        loadingState.loadingIncrement(this.loadingKey);
        await integrationRepository.manageSyncAll(this.selectedLocationIds);
        loadingState.loadingDecrement(this.loadingKey);
        this.close();
    }

    private close() {
        this.search = '';
        this.availableLocations = [];
        this.integratedCenters = [];
        this.selectedLocationIds = [];
        this.modelValue = false;
    }
}
